import React from "react";
import PdfBase from "./PdfBase";
import { generateFurtherDeductionPdf } from "./generator";
import ExcelBase from "../Excel/ExcelBase";

const PdfGenerator = ({
  schedule,
  company,
  expensesRows,
  totalExpenses,
  isExpenseCapped,
  isExcessDeductionEnabled,
  deductionRate,
  expenseCappedAmount,
  finalDeduction,
  exchangeRate,
  excessDeductionRate,
  excessDeductionDescription,
  excessDeduction,
  totalDeduction,
  notes,
  reviewNotes,
}) => {
  const sharedArgs = [
    schedule,
    company,
    expensesRows,
    totalExpenses,
    isExpenseCapped,
    deductionRate,
    expenseCappedAmount,
    finalDeduction,
    notes,
    reviewNotes,
  ];
  const deductionDetails = {
    isExcessDeductionEnabled,
    exchangeRate,
    excessDeductionRate,
    excessDeductionDescription,
    excessDeduction,
    totalDeduction,
  };

  return (
    <>
      <PdfBase
        company={company}
        enableDraftView
        generatePdf={(forView) =>
          generateFurtherDeductionPdf(
            forView,
            ...sharedArgs,
            false,
            deductionDetails
          )
        }
        downloadName='Further Deduction Schedule'
      />
      <ExcelBase
        generateExcel={(forView) =>
          generateFurtherDeductionPdf(
            forView,
            ...sharedArgs,
            true,
            deductionDetails
          )
        }
      />
    </>
  );
};

export default PdfGenerator;
